var render = function render(_c,_vm){return _c('div',{staticClass:"ordered-list container container--narrow text-center"},[_c('ol',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }